import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PlaceholderTagProps {
    children?: ReactNode
    tone?: 'light' | 'dark'
    className?: string
}

/* Marks content that is an editable placeholder until real information is added in the CMS. */
export const PlaceholderTag: FC<PlaceholderTagProps> = ({ children = 'Placeholder', tone = 'light', className }): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex items-center rounded-sm border border-dashed px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.16em]',
                tone === 'dark' ? 'border-cream/40 text-cream/75' : 'border-charcoal/40 text-charcoal/80',
                className
            )}
        >
            {children}
        </span>
    )
}
